import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getAffiliateDebitTransactions } from '../../actions';
import {
  AffiliateDebitTransactionItem,
  GetAffiliateDebitTransactionsResponse,
  PaginationInfo
} from '../../lib/types';

interface UseAffiliateDebitTransactionsProps {
  pageNumber?: number;
  perPage?: number;
}

const useAffiliateDebitTransactions = ({
  pageNumber = 1,
  perPage = 10
}: UseAffiliateDebitTransactionsProps) => {
  const queryParams = useMemo(() => {
    const params: Record<string, string | number> = {
      pageNumber,
      perPage
    };

    return params;
  }, [pageNumber, perPage]);

  const { data, isLoading, refetch } = useQuery<unknown, Error, GetAffiliateDebitTransactionsResponse>(
    ['/affiliate/v2/portal/affiliate-debit-transactions', queryParams],
    async () => {
      const response = await getAffiliateDebitTransactions(queryParams);
      return response;
    },
    {
      suspense: false,
      keepPreviousData: true
    }
  );

  const transactions: AffiliateDebitTransactionItem[] = useMemo(() => {
    const responseData = (data as GetAffiliateDebitTransactionsResponse)?.body || (data as unknown as { data: AffiliateDebitTransactionItem[]; pagination: PaginationInfo });
    return responseData?.data || [];
  }, [data]);

  const pagination: PaginationInfo | null = useMemo(() => {
    const responseData = (data as GetAffiliateDebitTransactionsResponse)?.body || (data as unknown as { data: AffiliateDebitTransactionItem[]; pagination: PaginationInfo });
    return responseData?.pagination || null;
  }, [data]);

  return {
    transactions,
    pagination,
    transactionsLoading: isLoading,
    refetchTransactions: refetch
  };
};

export default useAffiliateDebitTransactions;

